// removed by extract-text-webpack-plugin
module.exports = {"oy_button":"oy_button__1l4D9m_6","icon":"icon__yKdIOXFP","text":"text__3YoCgpk4","iconDown":"iconDown__wuHu-njf","seeMore":"seeMore__1_TlDH0y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYButton/index.module.less
// module id = 694
// module chunks = 1